
import './App.css';
import Todo from './components/Todo';

function App() {
  return (
    //tarun rathore
    <>
      <Todo/>
    </>
  );
}

export default App;
